import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Leftsidebar from "./Leftsidebar";
import Rightsidebar from "./Rightsidebar";
import Footer from "./Footer";
import { HiOutlineBars3 } from "react-icons/hi2";
import { FaRocketchat } from "react-icons/fa";

const Layout = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <>
      <div>
        <Header setChatOpen={setChatOpen} />

        <div className="layout-wrapper">

          <Leftsidebar
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            chatOpen={chatOpen}
            setChatOpen={setChatOpen}
          />

          <div className={`main-content ${chatOpen ? "chat-open" : ""}`}>
            <div>
              <Outlet />

              <div className="bottom-nav d-lg-none d-flex justify-content-around">

                <div
                  className={`text-center nav-item ${isSidebarOpen ? "activeSidebar" : ""}`}
                  onClick={() => {
                    setIsSidebarOpen(!isSidebarOpen);
                    setChatOpen(false);
                  }}
                >
                  <HiOutlineBars3 />
                  <span>Menu</span>
                </div>

                <div
                  className={`text-center nav-item ${chatOpen ? "activeSidebar1" : "" }`}
                  onClick={() => {
                    setChatOpen(!chatOpen);
                    setIsSidebarOpen(false);
                  }}
                >
                  <FaRocketchat />
                  <span>Chat</span>
                </div>
              </div>
            </div>
            <div>
          <Footer />
            </div>
          </div>

          <div
            className={`right-sidebar-wrapper ${chatOpen ? "open" : ""
              }`}
          >
            <Rightsidebar
              chatOpen={chatOpen}
              setChatOpen={setChatOpen}
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;